/**
 * subscription.js — Subscription/billing domain service.
 */
import {
  toApiUrl,
  fetchWithAuthRetry,
  jsonFetchOptions,
  parseJsonOrThrow,
  readApiErrorMessage,
} from './_core';

export async function getSubscriptionOrganizations(token = null, query = null) {
  const orgId = String(
    (query && typeof query === 'object'
      ? (query.org_id ?? query.organization_id ?? query.organizationId)
      : query) || ''
  ).trim();
  const qs = orgId ? `?org_id=${encodeURIComponent(orgId)}` : '';
  const response = await fetchWithAuthRetry(
    toApiUrl(`/subscription/organizations/${qs}`),
    jsonFetchOptions(token),
    token,
  );
  if (!response.ok) {
    const msg = await readApiErrorMessage(response, `Subscription organisations fetch failed (${response.status})`);
    throw new Error(msg);
  }
  return parseJsonOrThrow(response, 'Subscription organisations');
}

export async function getSubscriptionCurrent(organizationId, token = null) {
  const qs = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : '';
  const response = await fetchWithAuthRetry(
    toApiUrl(`/subscription/current/${qs}`),
    jsonFetchOptions(token),
    token,
  );
  if (!response.ok) {
    const msg = await readApiErrorMessage(response, `Subscription current fetch failed (${response.status})`);
    throw new Error(msg);
  }
  return parseJsonOrThrow(response, 'Subscription current');
}

export async function getSubscriptionUsage(organizationId, token = null) {
  const qs = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : '';
  const response = await fetchWithAuthRetry(
    toApiUrl(`/subscription/usage/${qs}`),
    jsonFetchOptions(token),
    token,
  );
  if (!response.ok) {
    const msg = await readApiErrorMessage(response, `Subscription usage fetch failed (${response.status})`);
    throw new Error(msg);
  }
  return parseJsonOrThrow(response, 'Subscription usage');
}

export async function createSubscriptionBillingPortal(organizationId, token = null) {
  const response = await fetchWithAuthRetry(
    toApiUrl('/subscription/billing-portal/'),
    {
      method: 'POST',
      ...jsonFetchOptions(token),
      body: JSON.stringify({ organization_id: organizationId }),
    },
    token,
  );
  if (!response.ok) {
    const msg = await readApiErrorMessage(response, `Billing portal session failed (${response.status})`);
    throw new Error(msg);
  }
  return parseJsonOrThrow(response, 'Billing portal session');
}
